import React, { useEffect, useState } from "react";
import popbg from "../../assests/popbg.png";
import { useObserver } from "mobx-react";
import { AiOutlineUpload } from "react-icons/ai";
import { useStores } from "../../store";
import { PrimaryButton } from "../reusble_components/buttons/primaryButton";
import {
  MdOutlineAddCircleOutline,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { OutlineButton } from "../reusble_components/buttons/OutlineButton";
import { uploadFileToAzure } from "../../services/azure";
import { apiPostPut } from "../../api/api_methods";
import Loader from "../reusble_components/loader";
import { IoCloseCircleOutline } from "react-icons/io5";
export default function ClientPopup(props) {
  const { PopupStore, UserStore, RecuiterStore } = useStores();
  const navigate = useNavigate();
  const [form, setform] = useState(false);
  const [fileName1, setFileName1] = useState("");
  const [url, seturl] = useState("");
  const [loader, setLoader] = useState(false);
  const [name, setname] = useState("");
  const [companyurl, setCompanyurl] = useState("");
  const [mail, setMail] = useState("");
  const [desc, setDesc] = useState("");
  const [edit, setEdit] = useState(false);
  useEffect(() => {
    console.log(props.data);
    
    if (props.data) {
      
      setform(true);
      setEdit(true);
      seturl(props.data.logo);
      setname(props.data.name);
      setCompanyurl(props.data.url);
      setMail(props.data.mail);
      setDesc(props.data.description);
      setFileName1(props.data.logo);
    }else{
      setform(false);
      seturl("");
      setname("");
      setCompanyurl("");
      setMail("");
      setDesc("");
      setFileName1("");

    }
  }, [props.data, PopupStore.client]);

  const closeThisPopUP = () => {
    setform(false);
    setFileName1("");
    seturl("");
    PopupStore.setClient(false);
  };

  const handleFileChange = async (e) => {
    try {
      const timestamp = Date.now().toString();
      const min = 1000;
      const max = 9999;
      const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
      const filename = randomNumber + timestamp;
      setFileName1(e.target.files[0].name);
      const fileUploaded = await uploadFileToAzure(
        filename,
        e.target.files[0],
        { action: "resume" }
      );
      const url = fileUploaded.url;
      seturl(url);
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  return useObserver(() => (
    <>
      {PopupStore.client ? (
        <div onClick={closeThisPopUP} className="absolute w-screen h-screen z-50 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40">
          <div onClick={(e) => e.stopPropagation()} className="fixed  inset-0 bg-bg3 z-50 flex flex-col justify-center rounded-xl items-center md:w-[60%] px-5 lg:w-[60%] w-[90%] h-fit m-auto shadow-lg overflow-y-auto no-scrollbar">
            <div className="flex flex-col justify-between  h-fit py-5 w-[100%] md:w-[100%] lg:w-[100%]  ">
              <Loader loader={loader} />
              <IoCloseCircleOutline
                className="text-primary absolute text-xl cursor-pointer  top-2 right-2"
                onClick={closeThisPopUP}
              />
              {!form ? (
                <div className="flex flex-col justify-between items-center  h-fit py-5 w-[100%] md:w-[100%] lg:w-[100%] ">
                  <span className="flex flex-col gap-1 items-center">
                    <p className="text-primary">Manage Your Talent Pipeline </p>
                    <p>Add New Clients and Jobs Effortlessly</p>
                  </span>
                  <img src={popbg} className="w-[80%] md:w-[40%]" />
                  <div className="flex flex-col md:flex-row justify-center gap-5 w-[80%] md:w-[60%]">
                    <OutlineButton
                      buttonName="Create new Jobpost"
                      className=" max-w-[40%]"
                      icon={<MdOutlineAddCircleOutline />}
                      onClick={() => {
                        closeThisPopUP();
                        navigate("/company/services");
                      }}
                    />
                    <PrimaryButton
                    className=" max-w-[40%]"
                      buttonName="Create new client"
                      icon={<MdOutlineAddCircleOutline />}
                      onClick={() => {
                        setform(true);
                      }}
                    />
                  </div>
                </div>
              ) : (
                <div className="h-fit flex justify-center md:px-10 lg:px-10 md:pt-12 lg:pt-12 py-2 px-1 w-[100%] md:w-[100%] lg:w-[100%] ">
                  <form
                    className=" w-full "
                    onReset={() => {
                      seturl("");
                      setname("");
                      setCompanyurl("");
                      setMail("");
                      setDesc("");
                      setFileName1("");
                    }}
                    onSubmit={async (e) => {
                      e.preventDefault();

                      const body = {
                        userId: JSON.parse(localStorage.getItem("user"))?._id,
                        name: e.target.name.value,
                        logo: url,
                        url: e.target.url.value,
                        mail: e.target.mail.value,
                        description: e.target.desc.value,
                      };
                      setLoader(true);
                      let res = null;
                      if (edit) {
                        res = await apiPostPut(
                          body,
                          `/clients/edit-client/${props.data._id}`,
                          "PUT"
                        );
                      } else {
                        res = await apiPostPut(
                          body,
                          "/clients/new-client",
                          "POST"
                        );
                      }
                      if (res.status === 200) {
                        
                        RecuiterStore.fetchClients().then(() => {
                          PopupStore.setClient(false);
                        alert(
                          edit
                            ? "Client details updated  successfully"
                            : "Client added  successfully"
                        );
                        setLoader(false);
                        })

                        
                      } else {
                        alert(res.body.message);
                        setLoader(false);
                      }
                      console.log(body);
                    }}
                  >
                    <span className="flex justify-between w-full">
                      <span className="font-semibold text-2xl">Add details</span>
                      {/* <button type="reset" className="text-primary opacity-50">
                        Reset
                      </button> */}
                    </span>

                    <div className="grid md:grid-cols-2 mt-5 gap-x-10 gap-y-5 md:gap-x-10 lg:gap-x-10">
                      <span className="flex flex-col ">
                      <label className="flex">Company Name <p className="text-primary">*</p> </label>
                        <input
                          name="name"
                          id="name"
                          type="text"
                          defaultValue={name}
                          className="border rounded-md px-4 h-10 text-gray-500 focus:outline-none md:w-full w-[80vw] lg:w-full"
                        />
                      </span>
                      <span className="flex flex-col ">
                      <label className="flex items-center pr-2">Company Logo <p className="text-primary">*</p> <p className="text-xs text-primary ml-auto">Recommended [56px x 56px]</p> </label>
                      <div className="relative flex items-center md:w-full lg:w-full w-[80vw] border  h-10 rounded-md">
                          {fileName1 ? (
                            <div className="flex items-center w-fit  px-1 gap-5 mx-2 max-w-[75%] rounded-[0.275rem] py-0.5 bg-[#e9e9e9]">
                              <p className=" overflow-hidden whitespace-nowrap text-gray-500 text-sm pl-1 text-center">
                                {fileName1}{" "}
                              </p>

                              <button
                                type="button"
                                className=" pl-2"
                                onClick={() => {
                                  setFileName1("");

                                  localStorage.removeItem("uploadedImage");
                                }}
                              >
                                <IoCloseCircleOutline className="text-[#767676]" />
                              </button>
                            </div>
                          ) : (
                            <p className="text-[#767676] px-4">Upload logo</p>
                          )}
                          <input
                            type="file"
                            id="header"
                            name="header"
                            onChange={handleFileChange}
                            className="absolute hidden inset-0 opacity-0 h-full cursor-pointer md:w-full w-[80vw] lg:w-full"
                            accept=".jpg, .png"
                          />
                          <button
                            type="button"
                            onClick={() =>
                              document.getElementById("header").click()
                            }
                            className="absolute right-0 top-0  font-bold py-3 text-xl px-2 rounded"
                          >
                            <AiOutlineUpload className="text-primary" />
                          </button>
                        </div>
                      </span>
                      <span className="flex flex-col ">
                      <label className="flex">Company URL <p className="text-primary">*</p></label>
                        <input
                          name="url"
                          defaultValue={companyurl}
                          id="url"
                          type="text"
                          className="border text-gray-500 w-[80vw] md:w-full lg:w-full rounded-md px-4 h-10 focus:outline-none"
                        />
                      </span>
                      <span className="flex flex-col ">
                      <label className="flex">Company Mail <p className="text-primary">*</p></label>
                        <input
                          name="mail"
                          defaultValue={mail}
                          id="mail"
                          type="email"
                          className="border text-gray-500 rounded-md px-4 h-10 focus:outline-none md:w-full w-[80vw] lg:w-full"
                        />
                      </span>
                    </div>
                    <span className="flex flex-col md:mt-5 lg:mt-5 mt-2 ">
                      <label className="flex">Company Description <p className="text-primary">*</p></label>
                      <textarea
                        type="text"
                        name="desc"
                        defaultValue={desc}
                        id="desc"
                        className={` border md:w-full w-[80vw] text-gray-500 lg:w-full  min-h-[5.5rem] p-2 rounded-md focus:outline-none resize-none`}
                      />
                    </span>
                    <div
                      className={`flex pt-5  items-center ${
                        props.data ? "justify-between" : "justify-between"
                      }`}
                    >
                      {!props.data ? (
                        <button
                          type="reset"
                          onClick={() => {
                            setform(false);
                          }}
                        >
                          Back
                        </button>
                      ) : (
                        <div
                          className="text-primary opacity-70 cursor-pointer"
                          onClick={() => {
                            RecuiterStore.deleteClient(props.data._id);
                            PopupStore.setClient(false);
                          }}
                        >
                          <button
                          className=" py-2 px-2  rounded-lg md:text-lg lg:text-lg text-sm"
                        type="submit"
                      >
                        Delete
                      </button>
                        </div>
                      )}
                      <button
                        className="bg-primary md:py-2 lg:py-2 py-1 md:px-14 lg:px-14 px-5 rounded-lg font-semibold text-sm md:text-lg lg:text-lg text-white"
                        type="submit"
                      >
                        {props.data ? "Update client " : " Add new client "}
                      </button>
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </>
  ));
}
